var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tw-pointer-events-none tw-rounded-lg tw-bg-gray-500 tw-px-2 tw-py-1 tw-text-xs tw-normal-case tw-text-white tw-absolute tw--top-7 tw-left-4 tw-w-max tw-max-w-64 tw-opacity-0 tw-transition-opacity tw-z-50",class:{ 'tw-opacity-100': _vm.showTooltip }},[_vm._v("\n  "+_vm._s(_vm.textValue)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }